const klarnaPriceFormatter = (price: number) => Math.round(price * 100);

export default klarnaPriceFormatter;
